// ══════════════════════════════════════════════════════════════════════════════════════════════
//  B-838 · EN EL IPHONE, TOCAR UN CAMPO ACERCABA LA PANTALLA Y YA NO SE PODÍA ALEJAR    (25-sep-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «En iPhone usando la app compilada, la app se hace zoom al cambiar a alguna pestaña y no deja quitarle
//  zoom, por lo tanto hay cosas que se cortan y hay que deslizar lateralmente la app, pasa lo mismo en /login».
//
//  POR QUÉ. iOS acerca la página SOLO al tocar un campo con letra de menos de 16 px, y en esta aplicación todos los
//  campos llevan 13 o 14 px (index.css; el del login, 14). Una pestaña que pone el cursor en su buscador al abrirse
//  hace lo mismo sin que nadie toque nada. En Safari se aleja pellizcando; dentro de la app compilada (las dos del
//  iPhone, la del equipo y la del paciente, cargan esta misma web en vivo) no, y la pantalla se queda cortada.
//
//  EL ARREGLO. En iOS, y solo en iOS, la etiqueta viewport lleva `maximum-scale=1.0`: iOS deja de acercar al escribir.
//  En Safari se sigue pudiendo ampliar pellizcando (Apple ignora ese límite para el pellizco desde iOS 10), así que
//  nadie pierde el zoom de accesibilidad; en la app, la pantalla ya no se descoloca. En Android no se toca nada: ahí
//  el navegador no acerca al escribir y el límite solo quitaría el pellizco.
//  Se hace al arrancar (main.jsx), ANTES de pintar nada: a esa hora todavía no hay ningún campo con el cursor.
//
//  Lo mide backend/routes/iphone-sin-zoom-al-escribir.test.js.
// ══════════════════════════════════════════════════════════════════════════════════════════════

export const VIEWPORT_IOS = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, viewport-fit=cover'

// iPhone, iPod y iPad. El iPad con iPadOS 13 o más se presenta como un Mac: se le reconoce porque es táctil.
export function esIos(nav) {
  if (!nav) return false
  const ua = String(nav.userAgent || '')
  if (/iPad|iPhone|iPod/.test(ua)) return true
  return nav.platform === 'MacIntel' && Number(nav.maxTouchPoints) > 1
}

// Devuelve true si ha puesto el límite (es iOS y hay etiqueta viewport). Nunca revienta: sin esto la app funciona igual.
export function evitarZoomAlEscribirEnIos(doc, nav) {
  try {
    const d = doc || (typeof document !== 'undefined' ? document : null)
    const n = nav || (typeof navigator !== 'undefined' ? navigator : null)
    if (!d || !esIos(n)) return false
    const meta = d.querySelector('meta[name="viewport"]')
    if (!meta) return false
    meta.setAttribute('content', VIEWPORT_IOS)
    return true
  } catch (_) {
    return false
  }
}
